import { useCallback, useEffect, useMemo } from 'react';
import reportsService from '../service/reportsService.mjs';
import { useFiscalReport } from './useFiscalReport.mjs';

/**
 * The period's FINAL claims (GET /reports/claims) for the page's scope.
 *
 * Shared by Breakdown, Claims by person and Downloads. The response's
 * `regions` - every region the caller may see - feeds the page's region
 * picker, so it lists every region in scope even while one is selected.
 */
export const useFinalClaims = (scope) => {
  const { fy, quarter, region, addRegions } = scope;
  const load = useCallback(
    () => reportsService.getClaims({ fy, quarter, region }),
    [fy, quarter, region]
  );
  const result = useFiscalReport(load, fy);
  const regions = result.data?.regions;

  useEffect(() => { addRegions(regions); }, [regions, addRegions]);

  const claims = useMemo(() => result.data?.claims || [], [result.data]);

  return { ...result, claims };
};

export default useFinalClaims;
